import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseURLProd } from "../../api";
import { toast } from "react-toastify";

const BackupHook = () => {
  const [marksData, setMarksData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [backupDataDetail, setBackupDataDetail] = useState([]);
  const [isSeatBooked, setIsSeatBooked] = useState(false);
  // const toggleModal = () => setShowModal(!showModal);
  const user_id =localStorage.getItem("userId");
  const [modalData, setModalData] = useState({
    backup_id: null,
    seatno: null,
    no_of_seat: null,
    user_id:user_id
  });

  const toggleModal = (backup_id,no_of_seat, seatno) => {
    setModalData({ user_id,backup_id, no_of_seat,seatno });
    setShowModal(true);
  };
  const cancelToggle =  (backup_id,no_of_seat, seatno) => {
    setModalData({ user_id,backup_id,no_of_seat, seatno });
    setCancelModal(true);
  }
  const toggleCloseModal =()=>setShowModal(!showModal);
  const cancelCloseToggle =()=>setCancelModal(!cancelModal);
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");

  const [topics, setTopics] = useState([]);
  const [nestedData, setNestedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [nestedActiveAccordion, setNestedActiveAccordion] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState(null); // Tracks active parent accordion
  const [activePopup, setActivePopup] = useState(false);

  const handlePopup = () => {
    setActivePopup(true);
  };

  // Fetch topics for the parent accordion
  useEffect(() => {
    const formData = new FormData();
    formData.append("user_id", userId);

    fetch(`${baseURLProd}show-backup-topic`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status) setTopics(data.data);
      });
  }, []);

  // Fetch nested data for a specific topic
  const fetchNestedData = (topic) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("topic", topic);
    formData.append("user_id", userId);

    fetch(`${baseURLProd}show-backup-center`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status) {
          setNestedData((prevState) => ({
            ...prevState,
            [topic]: data.data,
          }));
        }
        setLoading(false);
      });
  };

  const toggleAccordion = (index, topic) => {
    setActiveAccordion(index === activeAccordion ? null : index);
    if (!nestedData[topic]) {
      fetchNestedData(topic);
    }
  };
  const toggleNestedAccordion = (index, topic) => {
    setNestedActiveAccordion(index === nestedActiveAccordion ? null : index);
    if (!nestedData[topic]) {
      fetchNestedData(topic);
    }
 
  };

  const fetchdata =async()=>{
    const response =fetch ('fdsffd')
    const data = (await response).json()

    setMarksData(data)
  }
  const handleBackup = () => {
    navigate("/backup");
  };
  const handleBackupInner = (backupSkillId) => {
    const formData = new FormData();
    formData.append("backup_skill_id", backupSkillId);

    fetch(`${baseURLProd}backup-class-detail`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        navigate("/backupclasses", { state: { backupData: data } });
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const handleConfirmSelection = (user_id, backup_id,no_of_seat, seatno) => {
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("backup_id", backup_id);
    formData.append("no_of_seat", no_of_seat);
    formData.append("seatno", seatno);
  
    fetch(`${baseURLProd}backup-seat-booking`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === true) {
          toast.success(data.message);
          setTimeout(() => {
            handleBackupDetails(backup_id);
          }, 1000);
        } else {
          setShowModal(false);
          toast.info(data.message);
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };
  
  const handleBackupDetails = (backup_id) => {
    const formData = new FormData();
    formData.append("backup_skill_id", backup_id);
  
    fetch(`${baseURLProd}backup-class-detail`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        navigate("/bookedclassDetail", { state: { backupData: data } });
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };
  const handleCancelBooking = (user_id, backup_id,no_of_seat, seatno) => {
    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("backup_id", backup_id);
    formData.append("no_of_seat", no_of_seat);
    formData.append("seatno", seatno);
  
    fetch(`${baseURLProd}backup-seat-booking`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
          setCancelModal(false);
          toast.success(data.message);
          setTimeout(() => {
            window.location.reload();
          },  3500);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const handleSave = () => {
    setMarksData(true);
  };
  const handleBack = () => {
    navigate(-1);
  };

  return {
    handleSave,
    marksData,
    toggleModal,
    showModal,
    handleBackupInner,
    handleBack,
    backupDataDetail,
    toggleAccordion,
    topics,
    loading,
    nestedData,
    activeAccordion,
    toggleNestedAccordion,
    nestedActiveAccordion,
    handleBackup,
    handlePopup,
    cancelToggle,
    cancelModal,
    modalData,handleConfirmSelection ,isSeatBooked, setIsSeatBooked,toggleCloseModal,handleCancelBooking,cancelCloseToggle
  };
};

export default BackupHook;
